import {
  ClassSwiftIcon,
  MyViewboardIcon,
  OriginalIcon,
  TeamOneIcon,
} from '@vs/ui/vs-icons';
import { useEnv } from '@vs/utils/envConfig';

import { DataList } from './type';

export function useProductList(): DataList {
  const env = useEnv();
  return [
    {
      name: 'myviewboard',
      Icon: MyViewboardIcon,
      href: `${env.product.mvb}/settings/preferences`,
    },
    {
      name: 'classswift',
      Icon: ClassSwiftIcon,
      href: env.product.classSwift,
    },
    {
      name: 'teamone',
      Icon: TeamOneIcon,
      href: env.product.teamone,
    },
    {
      name: 'original',
      Icon: OriginalIcon,
      href: env.product.originals,
    },
  ];
}
